import React from "react";
import Reveal from "./Reveal";

export default function SectionHead({ eyebrow, title, lead, center = false, children }) {
  return (
    <Reveal className={`sec-head ${center ? "sec-head--center" : ""}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      {title && <h2 className="h2">{title}</h2>}
      {lead && <p className="lead">{lead}</p>}
      {children}
    </Reveal>
  );
}
